import { render, staticRenderFns } from "./bankapos.vue?vue&type=template&id=887c6e22&"
import script from "./bankapos.vue?vue&type=script&lang=js&"
export * from "./bankapos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports